var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3656 7.84082L6.36559 15.3408C6.29141 15.42 6.19349 15.4729 6.08661 15.4915C5.97974 15.5101 5.8697 15.4935 5.7731 15.4441C5.67651 15.3947 5.5986 15.3153 5.55113 15.2177C5.50366 15.1201 5.48921 15.0098 5.50996 14.9033L6.42621 10.3202L2.82434 8.96769C2.74698 8.93876 2.678 8.89111 2.62355 8.82901C2.5691 8.76691 2.53089 8.69229 2.51232 8.61181C2.49374 8.53134 2.4954 8.44751 2.51713 8.36783C2.53886 8.28815 2.57998 8.2151 2.63684 8.15519L9.63684 0.655191C9.71102 0.576025 9.80893 0.523135 9.91581 0.504501C10.0227 0.485867 10.1327 0.502501 10.2293 0.551892C10.3259 0.601282 10.4038 0.680751 10.4513 0.778304C10.4988 0.875858 10.5132 0.986204 10.4925 1.09269L9.57371 5.68082L13.1756 7.03144C13.2524 7.06057 13.3208 7.10817 13.3748 7.17002C13.4288 7.23187 13.4668 7.30608 13.4853 7.38609C13.5039 7.4661 13.5024 7.54944 13.4811 7.62874C13.4598 7.70805 13.4192 7.78089 13.3631 7.84082H13.3656Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningFill);
export default __webpack_public_path__ + "static/media/LightningFill.53102378a72d521d00940f0c0ff45b35.svg";
export { ForwardRef as ReactComponent };